import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Dispatch, connect } from 'react-redux';
import { AppActionCreators, IApplicationState, IMissedMatchOffersResponse, ReportActionCreators } from '@nkr/store/index';
import { IMissedMatchOffer } from '@nkr/models/index';
import { FormControl, Well } from 'react-bootstrap';
import { MatchHistoryType } from '@nkr/enums/match-history-type';
import Grid from './grid';
import { Utility } from '@nkr/services/utility';

interface IOwnProps {
    isCenterLogin: boolean,
    centerId: number
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getLateVxm: (centerId: number, year: number, month: number) => Promise<IMissedMatchOffersResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    data: IMissedMatchOffer[],
    recipientCenterId: number,
    type: number,
    currentMonth: string,
}

const getMonthOptions = () => Utility.getRange(moment().subtract(11, 'month'), moment().add(1, 'month'), 'month');

const getInitialMonth = (): string => {
    const month = new URLSearchParams(window.location.search).get('month');
    const selected = month ? _.find(getMonthOptions(), date => date.format('YYYY-MM') == month) : null;

    return (selected || moment()).format('MM/DD/YYYY');
};

class LateVxm extends React.Component<TProps, IState> {
    readonly state: IState = {
        data: [],
        recipientCenterId: 0,
        type: MatchHistoryType.MatchOffer,
        currentMonth: getInitialMonth(),
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let currentMonth = moment(this.state.currentMonth, 'MM/DD/YYYY');
        let year = currentMonth.get('year');
        let month = currentMonth.get('month') + 1;

        this.props.showLoading('Getting missed match offers, one moment please...').then(() => {
            this.props.getLateVxm(this.props.centerId, year, month).then(response => {
                this.setState({
                    data: response.data.results
                }, () => {
                    this.props.hideLoading();
                });
            });
        });
    }

    getFilteredData = () => {
        return this.state.data.filter(x=> {
            let centerFilter = this.state.recipientCenterId > 0 ? x.recipientCenterId == this.state.recipientCenterId : true;
            return centerFilter;
        });
    }

    handleRecipientCenterChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            recipientCenterId: parseInt(e.currentTarget.value)
        });
    }

    handleMonthChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            currentMonth: e.currentTarget.value
        }, () => {
            this.getData();
        });
    }

    render = () => {
        const data = this.getFilteredData();

        const recipientCenterList = _.sortBy(_.uniqBy(this.state.data.map(item => {
            return { id: item.recipientCenterId, alias: item.recipientCenter };
        }), item => item.id), item => item.alias);

        const dateRange = getMonthOptions();

        return (
            <>
                {this.props.isCenterLogin == false ?
                    <Well bsSize='sm' style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                                <div style={{ marginRight: 5 }}>Recipient Center:</div>
                                <div style={{ marginRight: 20 }}>
                                    <FormControl
                                        componentClass='select'
                                        value={this.state.recipientCenterId}
                                        onChange={this.handleRecipientCenterChange}>
                                        <option value={0}>- All Centers -</option>
                                        {recipientCenterList.map(center =>
                                            <option key={`ctr-${center.id}`} value={center.id}>{center.alias}</option>
                                        )}
                                    </FormControl>
                                </div>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ marginRight: 5 }}>Filter by Month:</div>
                                <div style={{ marginRight: 20 }}>
                                    <FormControl
                                        componentClass='select'
                                        value={this.state.currentMonth}
                                        onChange={this.handleMonthChange}>
                                        {dateRange.map(date =>
                                            <option key={`ctr-${date.format('MM/DD/YYYY')}`} value={date.format('MM/DD/YYYY')}>{date.format('MM/YYYY')}</option>
                                        )}
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                    </Well>
                    :
                    <Well bsSize='sm' style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 4.5, paddingBottom: 4.5, marginBottom: 5 }}>
                        <div style={{ display: 'flex', alignItems: 'center', fontSize: 12 }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ marginRight: 5 }}>Filter by Month:</div>
                                <div style={{ marginRight: 20 }}>
                                    <FormControl
                                        componentClass='select'
                                        bsSize='sm'
                                        value={this.state.currentMonth}
                                        onChange={this.handleMonthChange}>
                                        {dateRange.map(date =>
                                            <option key={`ctr-${date.format('MM/DD/YYYY')}`} value={date.format('MM/DD/YYYY')}>{date.format('MM/YYYY')}</option>
                                        )}
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                    </Well>
                }

                <Grid data={data} />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getLateVxm: (centerId, year, month) => {
            return dispatch(ReportActionCreators.getLateVxm(centerId, year, month));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(LateVxm);